export const dashboardRoute = {
  name: 'Bosh sahifa',
  to: '/',
  exact: true,
  icon: 'home',
  permission: 'padmin.dashboard.view'
};

export const analyticsRouteItems = [
  { name: 'Tekshirish', to: '/tekshirish', permission: 'padmin.analytics.view' },
  { name: 'Temperament', to: '/temperament', permission: 'padmin.analytics.view' },
  { name: 'Kommunikativ', to: '/kommunikativ', permission: 'padmin.analytics.view' },
  { name: 'Motivatsiya', to: '/motivatsiya', permission: 'padmin.analytics.view' },
  { name: 'Bezovtalanish', to: '/bezovtalanish', permission: 'padmin.analytics.view' },
  { name: 'Nevrasteniya', to: '/nevrasteniya', permission: 'padmin.analytics.view' },
  { name: 'Suitsid', to: '/suitsid', permission: 'padmin.analytics.view' },
  { name: 'Depressiya', to: '/depressiya', permission: 'padmin.analytics.view' },
  { name: 'Kasb testi', to: '/kasb-testi', permission: 'padmin.analytics.view' }
];

export const analyticsRoutes = {
  name: 'Tahlillar',
  icon: 'chart-pie',
  permission: 'padmin.analytics.view',
  children: analyticsRouteItems
};

export const studentsRoute = {
  name: 'Talabalar',
  icon: 'users',
  to: '/talabalar',
  permission: 'padmin.students.view'
};

export const passportRoute = {
  name: 'Psixologik pasport',
  icon: 'id-card',
  to: '/psixologik-pasport',
  permission: 'padmin.passport.view'
};

export const alertRouteItems = [
  { name: 'Suitsidlar', to: '/xavf-guruhlari/suitsidlar', permission: 'padmin.alerts.view' },
  { name: 'Depressiyalilar', to: '/xavf-guruhlari/depressiyalilar', permission: 'padmin.alerts.view' },
  { name: 'Melanxoliklar', to: '/xavf-guruhlari/melanxoliklar', permission: 'padmin.alerts.view' },
  { name: 'Bezovtalanish', to: '/xavf-guruhlari/bezovtalanish', permission: 'padmin.alerts.view' },
  { name: 'Nevrasteniya', to: '/xavf-guruhlari/nevrasteniya', permission: 'padmin.alerts.view' }
];

export const alertRoutes = {
  name: 'Xavf guruhlari',
  icon: 'exclamation-triangle',
  to: '/xavf-guruhlari',
  permission: 'padmin.alerts.view',
  children: alertRouteItems
};

export const buildResultsRoute = (items = []) => ({
  name: 'Natijalar',
  icon: 'chart-line',
  to: '/natijalar',
  permission: 'padmin.analytics.view',
  children: Array.isArray(items) ? items : []
});

export const resultsRoute = buildResultsRoute();

export const testSettingsItems = [
  { name: 'Test qo`shish', to: '/test-sozlamalari/test-qoshish', permission: 'padmin.tests.manage' },
  { name: 'Test biriktirish', to: '/test-sozlamalari/biriktirish', permission: 'padmin.tests.manage' },
  { name: 'Yil va chorak', to: '/test-sozlamalari/davr', permission: 'padmin.tests.manage' },
  { name: 'Foydalanuvchilar', to: '/test-sozlamalari/foydalanuvchilar', permission: 'padmin.users.manage' }
];

export const testSettingsRoute = {
  name: 'Test sozlamalari',
  icon: 'cog',
  permission: 'padmin.tests.manage',
  children: testSettingsItems
};

export const buildManagementRoutes = (resultItems = []) => [
  dashboardRoute,
  analyticsRoutes,
  studentsRoute,
  passportRoute,
  alertRoutes,
  buildResultsRoute(resultItems),
  testSettingsRoute
];

const managementRoutes = buildManagementRoutes();

export const topMenuRoutes = managementRoutes;

export const settingsRoutes = {
  name: 'Sozlamalar',
  to: '/pages/settings',
  permission: 'padmin.settings.view',
  children: [
    {
      name: 'Umumiy',
      to: '/pages/settings/general',
      permission: 'padmin.settings.view',
      children: [
        { name: 'Tizim ko`rinishi', to: '/pages/settings/general/appearance', permission: 'padmin.settings.view' },
        { name: 'Til va hudud', to: '/pages/settings/general/locale', permission: 'padmin.settings.view' }
      ]
    },
    {
      name: 'Menyu',
      to: '/pages/settings/navigation',
      permission: 'padmin.settings.view',
      children: [
        { name: 'Yuqori menyu', to: '/pages/settings/navigation/top', permission: 'padmin.settings.view' },
        { name: 'Yon menyu', to: '/pages/settings/navigation/vertical', permission: 'padmin.settings.view' },
        { name: 'Aralash rejim', to: '/pages/settings/navigation/combo', permission: 'padmin.settings.view' }
      ]
    },
    {
      name: 'Psixolog moduli',
      to: '/pages/settings/module',
      permission: 'padmin.settings.view',
      children: [
        { name: 'Tahlillar', to: '/pages/settings/module/analytics', permission: 'padmin.settings.view' },
        { name: 'Tekshirish paneli', to: '/pages/settings/module/review', permission: 'padmin.settings.view' },
        { name: 'Xavf guruhlari', to: '/pages/settings/module/alerts', permission: 'padmin.settings.view' }
      ]
    },
    {
      name: 'Xavfsizlik',
      to: '/pages/settings/security',
      permission: 'padmin.settings.view',
      children: [
        { name: 'Sessiya', to: '/pages/settings/security/session', permission: 'padmin.settings.view' },
        { name: 'Ruxsatlar', to: '/pages/settings/security/permissions', permission: 'padmin.settings.view' },
        { name: 'Foydalanuvchilar', to: '/pages/settings/security/users', permission: 'padmin.users.manage' }
      ]
    }
  ]
};

export const unavailableFeatureRoutes = [
  ...analyticsRouteItems.map(item => ({ ...item, section: 'Tahlillar' })),
  ...testSettingsItems.map(item => ({ ...item, section: 'Test sozlamalari' }))
];

export const unavailableFeatureRouteMap = unavailableFeatureRoutes.reduce((accumulator, route) => {
  accumulator[route.to] = route;
  return accumulator;
}, {});

export default managementRoutes;
